import { Component, OnInit } from '@angular/core';
import { MenuService } from 'src/app/core/services/menu.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class logoutComponent implements OnInit {

  constructor(private readonly menuService: MenuService) { }

  ngOnInit(): void {
    this.menuService.signout().subscribe();
  }

}
